import React, { useEffect ,useCallback, useState, useRef } from 'react';
import { useLocalization } from 'gatsby-theme-i18n';

import IconPackage from 'xiv-fanfes-2021'
import styled from '@emotion/styled';
import LinkItem from "../../../components/LinkItem"
import { useStaticQuery, graphql } from "gatsby"
import * as breakpoint from '../../../styles/breakpoints.module.scss';

import { useCurrentTime } from '../../../functions/useCurrentTime';
import { DateTime } from 'luxon';
import { useCookies } from 'react-cookie';


import { withPrefix } from 'gatsby'

const Notification = () => {
  const { currentTime } = useCurrentTime();

  const { localeKey, currentLocaleObj } = useLocalization();
  const [ onAir, setOnAir ] = useState(false);
  const [ fading, setIsFading ] = useState(false);
  const [ displayed, setDisplayed ] = useState(false);
  const [ cookies, setCookie ] = useCookies(['notification']);

  const timer = useRef(null);


  const { notificationTxt, allProgram } = useStaticQuery(graphql`
  query Notification {
    notificationTxt : notificationCsv(key: {regex: "/^notification.streaming.label/"}) {
      ...localizedContent
    }
    allProgram {
      nodes {
        data {
          start_time
          end_time
        }
      }
    }
  }
  `);



  const checkOnAir = useCallback(() => {
    
    let currentOnAir = false;
    allProgram.nodes.forEach((item,index) => {
      let startTime = DateTime.fromISO(item.data.start_time);
      let endTime = DateTime.fromISO(item.data.end_time);
      if(currentTime >= startTime && currentTime <= endTime)
      {
        currentOnAir = true;
      }
    });

    setOnAir(currentOnAir);
  },[allProgram,setOnAir, currentTime]);


useEffect(() => {
  if(!cookies.notification)
  {
    checkOnAir();
  }

}, [cookies, checkOnAir, currentTime]);


useEffect(() => {
  if(onAir && !displayed)
  {
    setDisplayed(true)
    setTimeout(() => {
      setIsFading(true);
    },100);
  } else if(!onAir && fading)
  {
    setIsFading(false);
    setTimeout(() => {
      setDisplayed(false);
    },500);
  }
}, [onAir, fading, displayed]);


  return (<NotificationWrapper className={`${onAir ? 'isOnAir' : ''} ${fading ? 'isFading' : ''} ${displayed ? 'isDisplayed' : ''}`}>
      <ContentWrapper to={`/${currentLocaleObj.prefix}/streaming/`} fade>
        <IconPackage.Icon type={"Meteor"} />
        <div>{notificationTxt[localeKey]}</div>
      </ContentWrapper>
      <CloseBtn href={"#"} onClick={(e) => {
        e.preventDefault();
        setCookie('notification', "read", { path: withPrefix('/') });
        setOnAir(false);
        clearInterval(timer.current);
      }}><IconPackage.Icon type={"Plus"} /></CloseBtn>
    </NotificationWrapper>);
}
 
export default Notification;


const NotificationWrapper = styled.div`
  width: 928px;
  max-width: calc(100% - 240px);
  position:absolute;
  top:0;
  left:50%;
  transform: translate(-50%,-50%);
  background: #EF2F51;
  border-radius: 24px;
  padding:0 24px;
  z-index:11;

  display:flex;
  justify-content:space-between;
  align-items: center;

  display:none;
  opacity:0;

  transition: opacity .5s;

  &.isDisplayed{
    display:flex;
  }
  &.isFading{
    opacity:1;
  }


  @media only screen and (max-width: ${breakpoint.smMax}){
    width: calc(100% - 160px);
    max-width:none;
    
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width: calc(100% - 48px);
    padding:0px 16px;
    
  }
`

const ContentWrapper = styled(LinkItem)`
  width:calc(100% - 40px);
  padding:12px 0px;
  color: #F7F7FA;
  text-decoration:none;

  

  text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.03em;
  display:flex;
  align-items: center;

  > div{
    width:calc(100% - 40px);
  }

  svg{
    width:24px;
    height:24px;
    margin-right:16px;
    vertical-align: text-bottom;
  }


  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 16px;
    padding:8px 0px;
    svg{
      width:16px;
      height:16px;
      margin-right:8px;
    }

    > div{
      width:calc(100% - 24px);
    }
  }
`

const CloseBtn = styled.a`
  display:block;
  width:24px;
  height:24px;
  color: #F7F7FA;
  position:relative;
  svg{
    width:24px;
    height:24px;
    margin-right:0px;
    transform: translate(-50%,-50%) rotate(45deg);
    position:absolute;
    top:50%;
    left:50%;

  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:16px;
    height:16px;
    svg{
      width:16px;
      height:16px;
    }
  }
`
